"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getColor = void 0;

const getColor = variant => variant === 'default' || variant === 'success' ? 'secondary04' : variant;

exports.getColor = getColor;